/* eslint-disable no-console */
import EditListingPhotosForm from './EditListingPhotosForm';

export const Empty = {
  component: EditListingPhotosForm,
  props: {
    initialValues: { country: 'US', images: [] },
    stripeConnected: false,
    onImageUpload: values => {
      
    },
    onSubmit: values => {
      
    },
    saveActionMsg: 'Save photos',
    updated: false,
    ready: false,
    updateInProgress: false,
    disabled: false,
    onUpdateImageOrder: imageOrder => {
      
    },
    onRemoveImage: imageId => {
      
    },
  },
  group: 'forms',
};
